const RequiredField = () => {
    return (
        <span className="ms-1 fs-bold">
        *
        </span>
    )
}

export default RequiredField;
